import { injectIntl } from 'react-intl';
import StationSelectField from './StationSelectField';

export default injectIntl(StationSelectField);
